
export const GRAMS_PER_POUND = 453.592;
